import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from "styled-components";
import { useDispatch, useSelector } from 'react-redux';
import * as moment from 'moment';
import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import CheckboxInput from 'web/components/form-elements/CheckboxInput';
import AlertModal from 'web/components/AlertModal';
import ConfirmationModal from "web/components/ConfirmationModal";
import YesNoModal from 'web/components/YesNoModal';
import { sellerPickupOrderCheckoutAcceptApi } from 'redux/actions/checkout';
import { pickupOrderDeclineApi } from "redux/actions/myPickupOrders"
import PaymentModule from '../PaymentModule';
import { PayWith, RequestPickUpAddressStyle, TendorDetailsWrapper, Footerstyle, Heading, AccountSection, AccountType, Location, } from '../checkOutStyle';
import { fetchLanguageContentNew } from 'redux/actions/language';

const ViewDetails = ({ callBackCheckoutFetchApi, checkoutPageData, props }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const token = localStorage.getItem('token');

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()

  const [alertType, setAlertType] = useState('')
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const toggleModal = () => setModal(!modal);

  const [confirmationComment, setConfirmationComment] = useState("");
  const [yesNoConfirmationmodal, setYesNoConfirmationModal] = useState(false);
  const [yesNoConfirmationModalContent, setYesNoConfirmationModalContent] = useState("");

  const [yesNomodal, setYesNoModal] = useState(false);
  const [yesNoModalContent, setYesNoModalContent] = useState("");

  useEffect(() => {
    if (languageContentNew?.Pallets_Listing_Pages) setPageLanguageContents(languageContentNew.Pallets_Listing_Pages)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  const declinePickupOrderFunc = () => {
    setAlertType('declineOrder')
    setYesNoConfirmationModalContent("Please provide a reason for declining this pickup load request.");
    setYesNoConfirmationModal(true);
  }

  const declinePickupOrderConfirmation = async () => {
    let response;
    setYesNoConfirmationModal(false)
    const token = localStorage.getItem('token');
    let data = {
      locationId: localStorage.getItem('locationId'),
      tenderId: checkoutPageData?.tenderId,
      comment: confirmationComment ?? null,
      tenderStatus: 'REJECTED'
    }
    response = await dispatch(pickupOrderDeclineApi(data, token));
    if (response?.success) {
      setAlertType('sellerPickupOrderCheckoutDecline');
      setModalContent(response?.data?.msg);
      setModal(true);
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModal(true);
      }
    }
  }

  const acceptFunction = () => {
    let pageValues = props.values
    if (pageValues?.paymentMethod === 'CREDIT_CARD') {
      setAlertType('acceptOrder')
      setYesNoModalContent("Are you sure you want to pay with a Credit Card? We recommend choosing ACH for payment as it has a nominal payment entity fee. See the terms and conditions for more details.");
      setYesNoModal(true);
    } else {
      acceptPickupOrderConfirmation()
    }
  }

  const acceptPickupOrderConfirmation = async () => {
    let pageValues = props.values
    if (pageValues?.achSelected && pageValues.achBackUpCard === '') {
      setModalContent('Please select a backup card for ACH mode of payment.');
      setModalLink();
      toggleModal();
      return
    }
    let response;
    let data = {
      tenderId: checkoutPageData?.tenderId,
      locationId: localStorage.getItem('locationID'),
      paymentMethod: pageValues?.paymentMethod,
      paymentMethodId: pageValues?.cardTypeRadio,
      backupPaymentMethodId: null,
      comments: pageValues?.note
    }
    if (pageValues?.achSelected) {
      data.backupPaymentMethodId = pageValues?.achBackUpCard
    }
    response = await dispatch(sellerPickupOrderCheckoutAcceptApi(data, token));
    if (response?.success) {
      setAlertType('sellerPickupOrderCheckoutAccept')
      setModalContent(response?.data?.msg);
      setModalLink();
      toggleModal();
      setYesNoModal(false)
    } else {
      if (response?.statusCode === 401) {
        history.push('./sign-in')
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  }

  const checkBoxlabel = () => {
    return <p style={{ margin: 0 }}>By accepting this pickup, you agree to the terms and conditions outlined <span style={{ color: 'blue' }} onClick={() => {
      window.open(process.env.REACT_APP_WEB_URL + 'checkout-terms-and-conditions', "_blank")
    }}>here</span>. </p>
  }

  return (
    <>
      <div></div>
      <div className="checkout-cont">
        <Description>
          <div className="product-header-sec">
            <img
              src={RightArrow}
              alt="RightArrow"
              className="right-arrow"
            />
            <div class="community-name" style={{ fontWeight: 'bold' }}>Review Pickup Request</div>
          </div>
          <p>Please review the following pickup request details and accept the load. Upon acceptance, the pickup order will be created and the sort form will be available for download.</p>
        </Description>
        <PayWith>
          <Location>
            <Heading>
              {pageLanguageContents?.BuyModal[24]?.PayWith}
            </Heading>
            <AccountSection>
              <AccountType>
                <PaymentModule
                  props={props}
                  checkoutPageData={checkoutPageData}
                  callBackCheckoutFetchApi={callBackCheckoutFetchApi}
                />
              </AccountType>
            </AccountSection>
            <Heading>Pickup Address:</Heading>
            <RequestPickUpAddressStyle>
              <div>
                <p style={{ fontWeight: 'bold' }}>{checkoutPageData?.pickupAddress?.locationName}</p>
                <p>{checkoutPageData?.pickupAddress?.street}</p>
                <p>{checkoutPageData?.pickupAddress?.city}, {checkoutPageData?.pickupAddress?.state} {checkoutPageData?.pickupAddress?.zipCode}</p>
              </div>
            </RequestPickUpAddressStyle>

            <TendorDetailsWrapper>
              <div>
                <p>Estimated Order Quantity</p>
                <input disabled value={checkoutPageData?.quantity} />
              </div>
              <div>
                <p>Equipment</p>
                <input disabled value={checkoutPageData.loadingRequirement === 'DROP_TRAILER' ? 'Drop Trailer' : checkoutPageData.loadingRequirement === 'LIVE_LOAD' ? 'Live Load' : 'NA'} />
              </div>
            </TendorDetailsWrapper>

            <TendorDetailsWrapper>
              <div>
                <p>Req. Pickup Date</p>
                <input disabled value={moment(checkoutPageData?.pickupDate).format('MM/DD/YYYY')} />
              </div>
              <div>
                <p>Pickup Window</p>
                <div className='pickup-window-calss'>
                  <input disabled value={checkoutPageData?.appointmentStartTime} />
                  <p>To</p>
                  <input disabled value={checkoutPageData?.appointmentEndTime} />
                </div>
              </div>
            </TendorDetailsWrapper>


            <Heading>Review Order:</Heading>
            <hr style={{ margin: '0px' }} />

            <div className="checkout-note">
              <p className='buyer-comment'><span>Buyer Comment:</span>{checkoutPageData?.comment}</p>
              <Heading style={{ marginTop: '0px' }}>Notes to PT+ Admin</Heading>
              <div className="app-input-text">
                <textarea
                  name="note"
                  maxLength="200"
                  onChange={(event) => {
                    const { setFieldValue } = props
                    if (event.target.value?.length < 201) setFieldValue('note', event.target.value)
                  }}
                />
              </div>
            </div>
            {props.values?.achSelected &&
              <div>
                <CheckboxInput
                  name="achAcknowledgeCheck"
                  label="I authorize that you can withdraw funds from my ACH account. If it fails, you can use my credit card."
                  handleSelect={() => { }}
                />
              </div>
            }
            <div>
              <CheckboxInput
                name="pickupRequestSellerAcknowledgeCheck"
                label={checkBoxlabel()}
                handleSelect={() => { }}
              />
            </div>
            <Footerstyle>
              <button
                className='accept-button'
                type=''
                onClick={() => acceptFunction()}
                disabled={(props.values?.achSelected && !props.values.achAcknowledgeCheck) || (!props.values.pickupRequestSellerAcknowledgeCheck)}>
                Accept
              </button>
              <button
                className='reject-button'
                type=''
                onClick={() => declinePickupOrderFunc()}>
                {pageLanguageContents?.BuyModal[40]?.Reject}
              </button>
            </Footerstyle>
          </Location>
        </PayWith>

      </div >
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=''
        content={modalContent}
        link={modalLink}
        alertType={alertType}
        callBackAlert={() => {
          if (alertType === 'sellerPickupOrderCheckoutDecline') {
            history.push({ pathname: "/my-pickup-orders", });
          } else if (alertType === 'sellerPickupOrderCheckoutAccept') {
            localStorage.setItem('redirectPickupOrderTabValue', 1)
            history.push({ pathname: "/my-pickup-orders", });
          }
        }}
      />
      <ConfirmationModal
        isOpen={yesNoConfirmationmodal}
        toggle={() => {
          setYesNoConfirmationModal(!yesNoConfirmationmodal);
          setConfirmationComment("");
        }}
        onClickHander={(val) => {
          if (val === "no") {
          } else {
            if (alertType === 'declineOrder') declinePickupOrderConfirmation()
          }
        }}
        content={yesNoConfirmationModalContent}
        confirmationComment={confirmationComment}
        setconfirmationComment={setConfirmationComment}
      />
      <YesNoModal
        isOpen={yesNomodal}
        toggle={() => setYesNoModal(!yesNomodal)}
        title=""
        content={yesNoModalContent}
        link={"/"}
        onClickHander={(val) => {
          if (val === "no") {
          } else {
            if (alertType === 'acceptOrder') acceptPickupOrderConfirmation()
          }
        }}
      />
    </>
  );
};

export default ViewDetails;
const Description = styled.div`
  position: relative;
  padding-left: 62px;

  img.right-arrow {
    position: absolute;
    left: -36px;
  }
  .product-header-sec{
    margin-top: 10px;
    margin-bottom: 10px;
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    @media (max-width: 767px) {
      grid-template-columns: 80% 1fr;
    }
  }
`;
